import { baseSepolia } from 'viem/chains';
import { Percent } from '@uniswap/sdk-core';

export const EXPECTED_CHAIN = baseSepolia;
// reference: https://github.com/Uniswap/interface/blob/be21e4834f44ff4b9c842ae6c68a81df3be2c891/apps/web/src/pages/RemoveLiquidity/index.tsx#L61
export const DEFAULT_ADD_LIQUIDITY_SLIPPAGE_TOLERANCE = new Percent(50, 10_000);
export const DEFAULT_REMOVE_LIQUIDITY_SLIPPAGE_TOLERANCE = new Percent(50, 10_000);
// Default deadline of 30 minutes in seconds
export const DEFAULT_EXECUTION_DEADLINE_DELTA_SECONDS = 30 * 60;
